import { Seo } from '../components/Seo';
import { Hero } from '../sections/Hero';
import { Stats } from '../sections/Stats';
import { HowItGoes } from '../sections/HowItGoes';
import { Pour } from '../sections/Pour';
import { Pricing } from '../sections/Pricing';
import { Faq } from '../sections/Faq';
import { FinalCta } from '../sections/FinalCta';
import { StructuredData } from '../components/StructuredData';

export default function HomePage() {
  return (
    <>
      <Seo path="/" />
      <StructuredData />

      <div className="container">
        <Hero />
        <Stats />
        <HowItGoes />
        <Pour />
        <Pricing />
        <Faq />
        <FinalCta />
      </div>
    </>
  );
}
